import { apwRetry } from "./retry";
import { getClient } from "./gqlClient";
import { getError } from "./GqlError";
export { wrapQuery };
async function wrapQuery(api, query, variables) {
  return await apwRetry(async function () {
    try {
      return await getClient().request(query, variables);
    } catch (e) {
      e.apiName = api;
      throw getError(e);
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/utils/wrapQuery.js
// module id = 178
// module chunks = 11